import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import CommodityClassificationForm from "components/CommodityClassification/form"
import { storeCommodityClassification } from "store/commodity-classification/commodity-classification-action"

const AddCommodityClassification = () => {
  document.title = "Add Unit Classification"
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, error } = useSelector(state => state.commodityClassification)

  return (
    <CommodityClassificationForm
      onSubmit={values =>
        dispatch(storeCommodityClassification(values, navigate))
      }
      loading={loading}
      error={error}
      formMode={"Add"}
    />
  )
}

export default AddCommodityClassification
